import { string2money } from 'common/utils/string';
import { Input, TableComponent } from 'components/elements';
import { TableContainer } from 'components/styles';
import { format } from 'date-fns';
import SalePillStatus from 'legacy-modules/sales/component/status';
import {
  FullContainer,
  HalfContainer,
  SectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import { useFormContext, useWatch } from 'react-hook-form';

const columns = (t) => [
  {
    header: t('common:invoice_number'),
    accessorKey: 'invoiceNumber',
    minSize: 200,
  },
  {
    header: t('common:status'),
    accessorKey: 'status',
    minSize: 200,
    cell: ({ getValue }) => <SalePillStatus value={getValue() as string} />,
  },
  {
    header: t('debt:due_date'),
    accessorKey: 'dueDate',
    minSize: 150,
    cell: ({ row }) => {
      const { original } = row;
      if (original.dueDate) {
        return <>{format(new Date(original.dueDate), 'dd MMMM yyyy')}</>;
      } else {
        return <>-</>;
      }
    },
  },
  // {
  //   header: t('common:billing_to'),
  //   accessorKey: 'billingTo',
  //   minSize: 200,
  // },
  {
    header: t('debt:invoice_total'),
    accessorKey: 'total',
    minSize: 150,

    cell: ({ getValue }) => <>{string2money(getValue() as number)}</>,
  },
  {
    header: t('debt:paid_amount'),
    accessorKey: 'paidAmount',
    minSize: 150,

    cell: ({ getValue }) => <>{string2money(getValue() as number)}</>,
  },
  {
    header: t('debt:due_amount'),
    accessorKey: 'dueAmount',
    minSize: 150,
    cell: ({ row }) => {
      const { original } = row;
      const result = original.total - original.paidAmount;
      return <>{string2money(result)}</>;
    },
  },
];
export default function ReceiptCard() {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const [receiptDetails] = useWatch({
    control,
    name: ['approvalable.receiptDetails'],
  });

  return (
    <>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="date-time"
            name="approvalable.transactionAt"
            label={t('common:transaction_at')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.number"
            label={t('common:number')}
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.customer"
            label={t('common:customer')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.billingTo"
            label={t('common:billing_to')}
          />
        </HalfContainer>
      </SectionContainer>
      <FullContainer>
        <Input
          type="text"
          name="approvalable.description"
          label={t('common:description')}
        />
      </FullContainer>
      <TableContainer>
        <TableComponent columns={columns(t)} data={receiptDetails || []} />
      </TableContainer>
    </>
  );
}
